<template>
  <v-card>
    <v-card-title primary-title class="headline">
      <template v-if="type === 'add'">{{ $t('branch_add') }}</template>
      <template v-else-if="type === 'edit'">{{ $t('branch_edit') }}: {{ name }}</template>
    </v-card-title>
    <v-card-text>
      <form
        id="branchForm"
        autocomplete="off"
        novalidate
        :style="{ margin: '-0.25rem' }"
        @submit.prevent="handleSubmit"
      >
        <v-layout wrap>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('branchName') }"
          >
            <label class="d-block"
              >{{ $t('branch_name') }} <span class="error--text">*</span></label
            >
            <input
              v-model="form.branchName"
              v-validate="'required'"
              type="text"
              name="branchName"
              :data-vv-as="$t('branch_name')"
            />
            <p v-if="errors.has('branchName')" class="text-error">
              {{ errors.first('branchName') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('phoneNumber') }"
          >
            <label class="d-block">{{ $t('phone no.') }} <span class="error--text">*</span></label>
            <input
              v-model="form.phoneNumber"
              v-validate="'required|numeric'"
              type="tel"
              name="phoneNumber"
              :data-vv-as="$t('phone no.')"
            />
            <p v-if="errors.has('phoneNumber')" class="text-error">
              {{ errors.first('phoneNumber') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('googleMapUrl') }"
          >
            <label class="d-block">Google Map URL <span class="error--text">*</span></label>
            <input
              v-model="form.googleMapUrl"
              v-validate="'required|url'"
              type="url"
              name="googleMapUrl"
              :data-vv-as="'Google Map URL'"
            />
            <p v-if="errors.has('googleMapUrl')" class="text-error">
              {{ errors.first('googleMapUrl') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md8
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('address') }"
          >
            <label class="d-block">{{ $t('Address') }} <span class="error--text">*</span></label>
            <input
              v-model="form.address"
              v-validate="'required'"
              type="text"
              name="address"
              :data-vv-as="$t('Address')"
            />
            <p v-if="errors.has('address')" class="text-error">
              {{ errors.first('address') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('subdistrict') }"
          >
            <label class="d-block"
              >{{ $t('Subdistrict') }} <span class="error--text">*</span></label
            >
            <ThaiAddressInput
              v-model="form.subdistrict"
              type="district"
              @select="handleAddressSelect"
            />
            <input
              v-model="form.subdistrict"
              v-validate="'required'"
              type="hidden"
              name="subdistrict"
              :data-vv-as="$t('Subdistrict')"
            />
            <p v-if="errors.has('subdistrict')" class="text-error">
              {{ errors.first('subdistrict') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('district') }"
          >
            <label class="d-block">{{ $t('District') }} <span class="error--text">*</span></label>
            <ThaiAddressInput v-model="form.district" type="amphoe" @select="handleAddressSelect" />
            <input
              v-model="form.district"
              v-validate="'required'"
              type="hidden"
              name="district"
              :data-vv-as="$t('District')"
            />
            <p v-if="errors.has('district')" class="text-error">
              {{ errors.first('district') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('province') }"
          >
            <label class="d-block">{{ $t('Province') }} <span class="error--text">*</span></label>
            <ThaiAddressInput
              v-model="form.province"
              type="province"
              @select="handleAddressSelect"
            />
            <input
              v-model="form.province"
              v-validate="'required'"
              type="hidden"
              name="province"
              :data-vv-as="$t('Province')"
            />
            <p v-if="errors.has('province')" class="text-error">
              {{ errors.first('province') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('postcode') }"
          >
            <label class="d-block">{{ $t('Postcode') }} <span class="error--text">*</span></label>
            <ThaiAddressInput
              v-model="form.postcode"
              type="district"
              @select="handleAddressSelect"
            />
            <input
              v-model="form.postcode"
              v-validate="'required'"
              type="hidden"
              name="postcode"
              :data-vv-as="$t('Postcode')"
            />
            <p v-if="errors.has('postcode')" class="text-error">
              {{ errors.first('postcode') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('latitude') }"
          >
            <label class="d-block">{{ $t('latitude') }} <span class="error--text">*</span></label>
            <input
              v-model.number="form.latitude"
              v-validate="'required|decimal'"
              type="number"
              name="latitude"
              :data-vv-as="$t('latitude')"
            />
            <p v-if="errors.has('latitude')" class="text-error">
              {{ errors.first('latitude') }}
            </p>
          </v-flex>
          <v-flex
            xs12
            md4
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('longitude') }"
          >
            <label class="d-block">{{ $t('longitude') }} <span class="error--text">*</span></label>
            <input
              v-model.number="form.longitude"
              v-validate="'required|decimal'"
              type="number"
              name="longitude"
              :data-vv-as="$t('longitude')"
            />
            <p v-if="errors.has('longitude')" class="text-error">
              {{ errors.first('longitude') }}
            </p>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn @click="hadnleCancel">{{ $t('cancel') }}</v-btn>
      <v-btn type="submit" form="branchForm" color="primary">
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ThaiAddressInput from '@/components/elements/ThaiAddressInput'

export default {
  components: { ThaiAddressInput },
  props: {
    value: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: 'add',
      validator: (value) => ['add', 'edit'].includes(value)
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        branchName: '',
        phoneNumber: '',
        googleMapUrl: '',
        address: '',
        subdistrict: '',
        district: '',
        province: '',
        postcode: '',
        latitude: '',
        longitude: ''
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.form = { ...this.form, ...value }
      }
    }
  },
  methods: {
    async handleSubmit() {
      const isValid = await this.$validator.validate()
      if (isValid) {
        const { value: isConfirmed } = await this.$swal({
          title:
            this.type === 'edit'
              ? this.$t('branch_edit_question', { name: this.name })
              : this.$t('branch_add_question', { name: this.form.branchName }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (isConfirmed) {
          this.$emit('submit', this.form)
        }
      }
    },
    hadnleCancel() {
      this.$emit('cancel')
    },
    handleAddressSelect(address) {
      this.form = {
        ...this.form,
        subdistrict: address.district,
        district: address.amphoe,
        province: address.province,
        postcode: address.zipcode
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/Form.vue